import { createAction } from '@reduxjs/toolkit';
import * as containerConstants from './constants';
import type { Purchase, PurchaseItem } from '@/lib/types';

export const loadPurchases = createAction(containerConstants.LOAD_PURCHASES);

export const loadPurchasesSuccess = createAction(
  containerConstants.LOAD_PURCHASES_SUCCESS,
  (purchases: any[]) => ({ payload: { purchases } })
);

export const loadPurchasesError = createAction(
  containerConstants.LOAD_PURCHASES_ERROR,
  (error: string) => ({ payload: { error } })
);

export const savePurchaseRequest = createAction(
  'purchases/SAVE_PURCHASE_REQUEST',
  (purchase: { vendorId?: string; items: PurchaseItem[]; paidAmount: number; paymentMethod?: string }) => ({
    payload: { purchase },
  })
);

export const payPurchaseRequest = createAction(
  'purchases/PAY_PURCHASE_REQUEST',
  (purchaseId: string, amount: number, method?: string) => ({ payload: { purchaseId, amount, method } })
);

export const cancelPurchaseRequest = createAction(
  'purchases/CANCEL_PURCHASE_REQUEST',
  (id: string) => ({ payload: { id } })
);
